export const CONTACT_US_KEY = 'contactUs';

export const FETCH_CONTACT_US_SUBJECTS = `${CONTACT_US_KEY}/FETCH_CONTACT_US_SUBJECTS`;
export const FETCH_CONTACT_US_SUBJECTS_SUCCESS = `${CONTACT_US_KEY}/FETCH_CONTACT_US_SUBJECTS_SUCCESS`;
export const FETCH_CONTACT_US_SUBJECTS_FAILURE = `${CONTACT_US_KEY}/FETCH_CONTACT_US_SUBJECTS_FAILURE`;
